import React from 'react';

// project-imports
import FooterOne from './footer/FooterOne';
import HeaderLandingPage from './header/HeaderLandingPage';
import { useCoursesContext } from '../context/courses_context';
import HeaderTwo from './header/HeaderTwo';

const Layout = ({ children, footerVariant, searchDisable=true }) => {

    // Extracting method from context
    const { setFilteredCourses } = useCoursesContext();

    return (
        <>
            <main className="main-wrapper">
                {/* <HeaderLandingPage setFilteredCourses={setFilteredCourses} searchDisable={searchDisable} /> */}
                <HeaderTwo setFilteredCourses={setFilteredCourses} searchDisable={searchDisable} />
                {children}
                {!footerVariant &&
                    <FooterOne />
                }
            </main>
        </>
    )
}
export default Layout;